import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { inputPropType } from '../propTypes';

export default class Input extends Component {
  static propTypes = {
    ...inputPropType,
    allowZero: PropTypes.bool,
    autoFocus: PropTypes.bool,
    field: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
  }

  static defaultProps = {
    type: 'number',
  }

  handleInputChanged = (e) => {
    let value = (e.target.value && e.target.value.trim()) || ''

    if (this.props.type === 'number') {
      // If this is a number input, cast the value to a number. But first check for empty string.
      if (value === '') {
        value = null
      } else {
        value = Number(value)
      }

      // If we don't allow zero and the value *is* zero, set it to null as a way to "clear" the input.
      if ((! this.props.allowZero) && (value === 0)) {
        value = null
      }
    }

    this.props.onChange(value)
  }

  render() {
    const {
      active,
      autoFocus,
      field,
      placeholder,
      prefix,
      readOnly,
      small,
      suffix,
      type,
    } = this.props

    const controlClasses = classnames([
      'form__control',
      'form__control--input',
      active && 'form__control--active',
      prefix && 'form__control--input-addon',
      suffix && 'form__control--input-addon',
      small && 'form__control--sm',
      readOnly && 'form__control--readonly',
    ])

    let value = this.props.value || ''

    if (this.props.allowZero && (this.props.value === 0 || value === '')) {
      value = 0
    }

    let min

    if (type === 'number') {
      min = 0
    }

    return (
      <div className={controlClasses}>
        {prefix && (
          <div className='input-addon input-addon--prefix'>
            {prefix}
          </div>
        )}

        <input
          autoFocus={autoFocus}
          className='form__input'
          id={field}
          min={min}
          placeholder={placeholder}
          readOnly={readOnly}
          onChange={readOnly ? null : this.handleInputChanged}
          type={type}
          value={value}
        />

        {suffix && (
          <div className='input-addon input-addon--suffix'>
            {suffix}
          </div>
        )}
      </div>
    )
  }
}
